<!--
 * @version: V1.0.0
 * @Date: 2023-08-14 16:25:54
 * @LastEditors: lzq
 * @LastEditTime: 2024-01-10 11:17:07
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\views\receiptDelivery\components\detialReceipt.vue
 * @Descripttion:
-->
<!--  -->
<template>
  <el-drawer v-loading.fullscreen="loading" :visible="visible" size="60%" :destroy-on-close="true"
    :wrapper-closable="false" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
    <div slot="title" style="display: flex;justify-content: space-between;">
      <div>查看</div>
      <div>
        <el-button @click="$emit('close')"> 返回 </el-button>
      </div>
    </div>
    <el-card class="udi-form group-box no-border" shadow="never">
      <div class="box-title">出入库记录</div>
      <el-table ref="dataTable" align="center" :data="dataList">
        <el-table-column show-overflow-tooltip prop="code" label="UDI码" />
        <el-table-column width="150px" show-overflow-tooltip prop="bizCode" label="单据编号" />
        <el-table-column width="150px" show-overflow-tooltip label="操作时间">
          <template slot-scope="{row }">
            {{ inventoryInfo.createTime ? parseTime(row.createTime) : null }}
          </template>
        </el-table-column>
        <el-table-column width="150px" show-overflow-tooltip label="状态">
          <template slot-scope="scope">
            <dict-tag :options="dictObj.receiptDeliveryState" :value="scope.row.state" />
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="searchParam.total > 0" :total="searchParam.total" :page.sync="searchParam.pageNum"
        :limit.sync="searchParam.pageSize" @pagination="getList" />
    </el-card>
  </el-drawer>
</template>

<script>
import { getReciptDeliveryDetail } from '@/api/reciptDelivery'

export default {
  name: 'DetialReceipt',
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      }
    },
    inventoryInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    dictObj: {
      type: Object,
      default() {
        return {
          receiptDeliveryState:[]
        }
      }
    }
  },
  data() {
    // 这里存放数据
    return {
      loading: false,
      dataList: [],
      searchParam: {
        pageSize: 10,
        pageNum: 1,
        total: 0
      }
    }
  },
  created() {
    this.searchParam = Object.assign(this.$data.searchParam, this.$options.data.call(this)).searchParam
    if (this.inventoryInfo.id) {
      this.getList(this.inventoryInfo)
    }
  },
  // 方法集合
  methods: {
    // 获取出入库记录
    getList() {
      getReciptDeliveryDetail({ inOutId: this.inventoryInfo.id, ...this.searchParam }).then((res) => {
        this.dataList = res.rows
        this.searchParam.total = res.total
      })
    },
  }
}
</script>

<style scoped>
.gird-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr)
}
</style>
